import { ExpenseCurrencyEnum } from 'src/types/expense-invoice';

/**
 * Convierte el enum de moneda a su símbolo correspondiente
 */
export function getCurrencySymbol(currency?: number | ExpenseCurrencyEnum): string {
  switch (currency) {
    case ExpenseCurrencyEnum.EUR:
      return '€';
    case ExpenseCurrencyEnum.GBP:
      return '£';
    case ExpenseCurrencyEnum.USD:
      return '$';
    case ExpenseCurrencyEnum.MXN:
      return 'MX$';
    case ExpenseCurrencyEnum.ARS:
      return 'AR$';
    case ExpenseCurrencyEnum.COP:
      return 'CO$';
    case ExpenseCurrencyEnum.CLP:
      return 'CL$';
    case ExpenseCurrencyEnum.PEN:
      return 'S/';
    default:
      return '€'; // Por defecto EUR
  }
}

/**
 * Convierte el enum de moneda a su código de 3 letras
 */
export function getCurrencyCode(currency?: number | ExpenseCurrencyEnum): string {
  switch (currency) {
    case ExpenseCurrencyEnum.EUR:
      return 'EUR';
    case ExpenseCurrencyEnum.GBP:
      return 'GBP';
    case ExpenseCurrencyEnum.USD:
      return 'USD';
    case ExpenseCurrencyEnum.MXN:
      return 'MXN';
    case ExpenseCurrencyEnum.ARS:
      return 'ARS';
    case ExpenseCurrencyEnum.COP:
      return 'COP';
    case ExpenseCurrencyEnum.CLP:
      return 'CLP';
    case ExpenseCurrencyEnum.PEN:
      return 'PEN';
    default:
      return 'EUR'; // Por defecto EUR
  }
}

/**
 * Obtiene todas las monedas disponibles como array de objetos
 */
export function getAllCurrencies() {
  return [
    { value: ExpenseCurrencyEnum.EUR, label: 'EUR', symbol: '€' },
    { value: ExpenseCurrencyEnum.USD, label: 'USD', symbol: '$' },
    { value: ExpenseCurrencyEnum.GBP, label: 'GBP', symbol: '£' },
    { value: ExpenseCurrencyEnum.MXN, label: 'MXN', symbol: 'MX$' },
    { value: ExpenseCurrencyEnum.ARS, label: 'ARS', symbol: 'AR$' },
    { value: ExpenseCurrencyEnum.COP, label: 'COP', symbol: 'CO$' },
    { value: ExpenseCurrencyEnum.CLP, label: 'CLP', symbol: 'CL$' },
    { value: ExpenseCurrencyEnum.PEN, label: 'PEN', symbol: 'S/' },
  ];
}

/**
 * Obtiene las monedas principales (EUR, USD, GBP)
 */
export function getMainCurrencies() {
  return [
    { value: ExpenseCurrencyEnum.EUR, label: 'EUR', symbol: '€' },
    { value: ExpenseCurrencyEnum.USD, label: 'USD', symbol: '$' },
    { value: ExpenseCurrencyEnum.GBP, label: 'GBP', symbol: '£' },
  ];
}
